import { observable, action } from 'mobx';
import { toast } from "react-toastify";
import IList from "../../types/IList";
import IListService from "../../services/spi/IListService";
import FirebaseListService from "../../services/impl/firebase/FirebaseListService";

const BlankList = {
  uid: '',
  name: '',
  code: '',
  visible: true,
  editable: true,
  deletable: true,
  lastUpdatedOn: '',
  options: []
};

class ListStore {
  rootStore: any = null;
  listService = {} as IListService;

  @observable lists = [] as Array<IList>;
  @observable list: IList = {
    uid: '',
    name: '',
    code: '',
    visible: true,
    editable: true,
    deletable: true,
    lastUpdatedOn: '',
    options: []
  };

  constructor(rootStore: any) {
    this.rootStore = rootStore;
    this.listService = new FirebaseListService();
  }

  @action getLists= async () => {
    this.lists = await this.listService.getLists();
  }

  @action setAttribute = (attrName: string, attrValue: string) => {
    switch (attrName) {
      case 'name':
        this.list.name = attrValue
        this.list.code = this.list.name.replace(/\s+/g, '-').toUpperCase();
        return;
      case 'code':
        return this.list.code = attrValue;
      default:
        return;
    }
  }

  @action setBlankList = () => {
    this.list = BlankList;
  }

  @action setList = (data: IList) => {
    this.list = data;
  }

  @action saveList = async () => {
    const { uid } = this.list;
    try {
      if (uid) {
        await this.listService.updateList(this.list);
        toast.success("List Item Updated Successfully!");
      } else {
        await this.listService.createList(this.list);
        toast.success("List Item Added Successfully!");
      }
      this.lists = await this.listService.getLists();
    } catch (err) {
      toast.error("Error Saving List Item!");
    }
  }

  @action deleteList = async (uid: string) => {
    // Delete Call Here
    toast.success("List Deleted Successfully!");
  }

}

export default ListStore;
